/**
 * Modulo per la gestione delle tabelle responsive con funzionalit� di espansione
 * Converte le colonne nascoste in righe espandibili su dispositivi mobili
 */

// Flag per evitare doppia inizializzazione
let isInitialized = false;

/**
 * Aggiorna la visibilit� dei pulsanti di espansione in base alle colonne nascoste
 */
function updateExpandButtons(): void {
    // Cicla su tutte le tabelle .tablePlus nella pagina
    document.querySelectorAll<HTMLTableElement>('.tablePlus').forEach((table) => {
        const ths = table.querySelectorAll<HTMLTableCellElement>('thead th');
        let firstHiddenIdx = -1;

        ths.forEach((th, idx) => {
            if (getComputedStyle(th).display === 'none' && firstHiddenIdx === -1) {
                firstHiddenIdx = idx;
            }
        });

        table.querySelectorAll<HTMLTableRowElement>('tbody tr').forEach((tr) => {
            const btn = tr.querySelector<HTMLButtonElement>('.btn-expand-row');
            if (!btn) return;

            const cells = tr.querySelectorAll<HTMLTableCellElement>('td,th');
            if (firstHiddenIdx === -1) {
                btn.style.display = 'none';
            } else if (cells[firstHiddenIdx] && getComputedStyle(cells[firstHiddenIdx]).display === 'none') {
                btn.style.display = '';
            } else {
                btn.style.display = 'none';
            }
        });
    });
}

/**
 * Gestisce il click sul bottone "Dettagli" per espandere/collassare le righe
 */
function handleExpandButtonClick(btn: HTMLElement): void {
    const tr = btn.closest<HTMLTableRowElement>('tr');
    if (!tr) return;

    const detailTr = tr.nextElementSibling as HTMLTableRowElement | null;
    const arrow = btn.querySelector<HTMLElement>('.arrow');

    if (!detailTr || !detailTr.classList.contains('expand-row-details')) return;

    const detailTd = detailTr.querySelector<HTMLTableCellElement>('td');
    if (!detailTd) return;

    // Se gi� visibile, nascondi
    if (!detailTr.classList.contains('d-none')) {
        detailTr.classList.add('d-none');
        detailTd.innerHTML = '';
        if (arrow) arrow.classList.remove('active');
        return;
    }

    // Altrimenti, mostra e popola con le colonne nascoste
    const hiddenCells: string[] = [];
    const table = tr.closest<HTMLTableElement>('table');
    if (!table) return;

    const ths = table.querySelectorAll<HTMLTableCellElement>('thead th');
    const cells = tr.children;

    for (let i = 0; i < ths.length; i++) {
        const th = ths[i];
        const cell = cells[i] as HTMLTableCellElement | undefined;

        // Se la cella non esiste (es. colspan), salta
        if (!cell) continue;

        // Mostra solo se la cella � nascosta (display: none)
        if (getComputedStyle(cell).display === 'none') {
            const label = th.textContent?.trim() || '';
            const value = cell.innerHTML.trim();
            hiddenCells.push(`<div class="mb-1 d-flex justify-content-between align-items-center border-bottom pb-2 mb-2"><strong>${label}</strong> ${value}</div>`);
        }
    }

    detailTd.innerHTML = hiddenCells.join('');
    detailTr.classList.remove('d-none');
    if (arrow) arrow.classList.add('active');
}

/**
 * Nasconde tutti i dettagli espansi e resetta lo stato delle frecce
 */
function hideAllExpandedRows(): void {
    document.querySelectorAll<HTMLTableRowElement>('.tablePlus .expand-row-details').forEach((row) => {
        row.classList.add('d-none');
        const td = row.querySelector<HTMLTableCellElement>('td');
        if (td) td.innerHTML = '';
    });

    document.querySelectorAll<HTMLElement>('.tablePlus .btn-expand-row .arrow.active').forEach((arrow) => {
        arrow.classList.remove('active');
    });
}

/**
 * Attacca i listener ai nuovi bottoni di espansione (da chiamare dopo aggiornamenti dinamici della tabella)
 */
function attachExpandListeners(): void {
    // Rimuovi eventuali listener duplicati usando event delegation
    document.querySelectorAll<HTMLElement>('.tablePlus .btn-expand-row').forEach((btn) => {
        // Rimuovi eventuali listener precedenti clonando il nodo
        const newBtn = btn.cloneNode(true) as HTMLElement;
        btn.parentNode?.replaceChild(newBtn, btn);

        // Aggiungi il nuovo listener
        newBtn.addEventListener('click', () => handleExpandButtonClick(newBtn));
    });

    // Aggiorna la visibilit� dei bottoni
    updateExpandButtons();
}

/**
 * Inizializza la gestione delle tabelle responsive
 */
function initTablePlus(): void {
    // Evita doppia inizializzazione degli event listener
    if (isInitialized) {
        // Aggiorna solo lo stato dei pulsanti e riattacca i listener
        attachExpandListeners();
        return;
    }

    isInitialized = true;

    // Gestione click sul bottone "Dettagli"
    attachExpandListeners();

    // Aggiorna la visibilit� dei bottoni al resize e al caricamento
    window.addEventListener('resize', () => {
        updateExpandButtons();
        hideAllExpandedRows();
    });
}

// Inizializza quando il DOM � pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTablePlus);
} else {
    initTablePlus();
}

// Espone updateExpandButtons globalmente per compatibilit�
(window as any).updateExpandButtons = updateExpandButtons;

export { updateExpandButtons, hideAllExpandedRows, initTablePlus, attachExpandListeners };
